import type { SubmitBountyResponse } from '@roadfootage/api-client'

type BountyState = Pick<SubmitBountyResponse, 'isClaimed' | 'isPaidInFull' | 'expiresAt'>

export function isBountyExpired(bounty: BountyState, now = new Date()): boolean {
  return !!bounty.expiresAt && bounty.expiresAt <= now
}

// Closed means the poster has nothing left to do with it: claimed (the reward has moved), paid, or expired.
export function isBountyClosed(bounty: BountyState, now = new Date()): boolean {
  return !!bounty.isClaimed || !!bounty.isPaidInFull || isBountyExpired(bounty, now)
}
